import { SepomexResponse } from '../types';
import { API_URL } from '../../common/utils';

/**
 * Consulta la información de dirección basada en el código postal
 * @param zipCode - Código postal a consultar
 * @returns Promesa con la información de estado, ciudad y colonias
 */
const getLocationByZipCode = async (zipCode: string): Promise<SepomexResponse> => {
  try {
    // Validar que el código postal tenga 5 dígitos
    if (!zipCode || zipCode.length !== 5 || !/^\d+$/.test(zipCode)) {
      throw new Error('El código postal debe tener 5 dígitos numéricos');
    }

    const response = await fetch(`${API_URL}/sepomex?zip_code=${zipCode}`);
    
    if (!response.ok) {
      // Si el servidor responde con un error, verificamos el status code
      if (response.status === 404) {
        throw new Error('El codigo postal es invalido, no se encontraron resultados');
      }
      throw new Error(`Error al consultar el código postal: ${response.statusText}`);
    }
    
    const data: SepomexResponse = await response.json();
    
    // Verificar que la respuesta tiene la estructura esperada
    if (!data.state || !data.city || !Array.isArray(data.settlements)) {
      throw new Error('La respuesta del servidor no tiene el formato esperado');
    }
    
    // Verificar que hay resultados
    if (data.settlements.length === 0) {
      throw new Error('No se encontraron colonias para este código postal');
    }
    
    return data;
  } catch (error) {
    console.error('Error al consultar la información del código postal:', error);
    throw error;
  }
}; 

export {
  getLocationByZipCode,
};
